import { IImage } from '@clooper/core';
import { Pipe, PipeTransform } from '@angular/core';

/**
  * CoverImagePipe
  *
  * A pipe to return default image as cover image of a property.
  */
@Pipe({ name: 'coverImage' })
export class CoverImagePipe implements PipeTransform {

  /**
  * Returns default image from an array of property images.
  *
  * @param {IImage[]} images Array of property images.
  * @param {string} option Additional option.
  * @return {string} Returns an image url or description based on option passed.
  */
  transform(images: IImage[], option?: string): string {
    let coverImage: any = { url: '/assets/resource/default-img.png', description: '' };
    if (images?.length) {
      const image = images.find(img => img.is_default)
      if (image !== undefined) {
        coverImage = image;
      }
    }
    if (option === 'desc') {
      return coverImage.description
    } else {
      return coverImage.url;
    }
  }
}
